import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './MessagingMobileModal.css';

/**
 * Full-screen mobile messaging shell: locks background scroll, no close button.
 * App chrome is rendered in the header slot; dismiss via in-app navigation (back / home).
 */
export default function MessagingMobileModal({ open, appChrome, children, ariaLabelledBy = 'messaging-people-panel-title' }) {
  useEffect(() => {
    if (!open) return undefined;
    const root = document.documentElement;
    const prevOverflow = document.body.style.overflow;
    root.classList.add('messaging-mobile-modal-open');
    document.body.style.overflow = 'hidden';
    return () => {
      root.classList.remove('messaging-mobile-modal-open');
      document.body.style.overflow = prevOverflow || '';
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="messaging-mobile-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby={ariaLabelledBy}
    >
      {appChrome ? <div className="messaging-mobile-modal__app-header">{appChrome}</div> : null}
      <div className="messaging-mobile-modal__body">{children}</div>
    </div>,
    document.body
  );
}
